import React from 'react'
import { getTeamIc } from '../../../../Utils'
import { TeamFilled } from './styles'

type BarProps = {
  percent: string
  teamColor: string
  teamName?: string
}

export const BarTeam: React.FC<React.PropsWithChildren<BarProps>> = ({
  percent,
  teamColor,
  teamName,
}) => {
  return (
    <>
      <TeamFilled teamColor={teamColor} percent={percent}>
        <div className="con">
          {teamName && <img src={getTeamIc(teamName)} alt={`${teamName} logo`} />}
          <div className="percent">{percent}%</div>
        </div>
      </TeamFilled>
    </>
  )
}
